import { SectionHeading } from "@/components/common/SectionHeading";
import { PillLink } from "@/components/common/PillLink";
import { ProcessSteps } from "@/components/home/ProcessSteps";

export const ProcessSection = () => (
  <section className="relative bg-cream-deep section-y-card rounded-[40px] mx-3 sm:mx-6" aria-labelledby="process-title" data-testid="process-section">
    <div className="container-x">
      <SectionHeading id="process-title" eyebrow="The inquiry learning process" title="How a MUCCI learner grows"
        intro="A simple four-step cycle that keeps every learner questioning, building and improving." />
      <div className="mt-14"><ProcessSteps /></div>
      <div className="mt-12"><PillLink to="/approach" variant="primary" arrow data-testid="process-learn-more">Read about our approach</PillLink></div>
    </div>
  </section>
);
